<template>
	<div class="flex items-center gap-2 bg-grey-11 rounded-lg p-3">
		<div>
			<img v-if="$store.getters.paymentMethod == 'rped'" src="@/assets/logo/bank/bank-agi-2.png" alt="" class="w-4 ">
			<img v-else-if="$store.getters.paymentMethod == 'gopay'" :src="`${publicPath}assets/img/logo-gopay-2.jpg`" alt="" class="w-4 ">
		</div>

		<div class="grow">Avail. Balance</div>

		<div>
			<div v-if="this.$store.state.setBalancesApiStatus == 'loading'" class="">
				<Loader size_prop="0.75rem" borderSize_prop="0.2rem"></Loader>
			</div>
			<div v-else-if="isHideBalance" class="">
				⬤ ⬤ ⬤ ⬤ ⬤ ⬤ ⬤
			</div>
			<div v-else class="font-semibold">
				{{ currencySymbol }}
				{{ currency == 'idr'
					? numberFormatExtend(this.$store.state.availableTradeBalanceIdr.toFixed())
					: numberFormatExtend(this.$store.state.availableTradeBalanceUsd.toFixed())
				}}
			</div>
		</div>

		<div class="cursor-pointer" @click="toggleBalance()">
			<IconEyeClose v-if="isHideBalance" width_prop="1rem" height_prop="1rem" />
			<IconEyeOpen v-if="!isHideBalance" width_prop="1rem" height_prop="1rem" />
		</div>
		<div class="cursor-pointer" @click="refreshBalance()">
			<IconRefresh width_prop="1rem" height_prop="1rem" />
		</div>
	</div>
</template>

<script>
import IconEyeClose from '../icons/IconEyeClose.vue'
import IconEyeOpen from '../icons/IconEyeOpen.vue'
import IconRefresh from '../icons/IconRefresh.vue'
import Loader from '../Loader.vue'

export default {
	name: 'AvailableBalance_TradeTicket',

	components: {
		IconEyeClose,
		IconEyeOpen,
		IconRefresh,
		Loader,
	},

	data() {
		return {
			publicPath: process.env.BASE_URL,
			isHideBalance: false,
		}
	},

	computed: {
		currency() {
			return this.$store.state.currency
		},
	},

	methods: {
		toggleBalance() {
			this.isHideBalance = !this.isHideBalance
		},

		refreshBalance() {
			if (!this.$store.state.getDepositIsCooldown) {
				this.$store.dispatch('setBalances')
			}
		},
	}
}
</script>